import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

import { featureName, moduleName, operationName } from '../constant/user-role-constant';
import { UserAuthService } from '../services/user-auth.sevice';
import { UserPermission } from '../store/state/auth-user';

export interface Permission {
  practicePersonalInfoCreate: "practicePersonalInfoCreate";
  practicePersonalInfoEdit: "practicePersonalInfoEdit";
  practicePersonalInfoView: "practicePersonalInfoView";
  practicePersonalInfoDelete: "practicePersonalInfoDelete";
  practicePersonalInfoAll: "practicePersonalInfoAll";
}

@Directive({
  selector: '[appPracticePermission]'
})
export class AppPracticePermissionDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userAuthService: UserAuthService
  ) { }

  @Input('appPracticePermission') set appPracticeHasPermission(permissionKeys: (keyof Permission)[] | keyof Permission) {

    const permissionsArray = Array.isArray(permissionKeys) ? permissionKeys : [permissionKeys];
    const permissionSets: UserPermission[] = [];

    permissionsArray.forEach(permissionKey => {
      const mappedPermissions = this.mapPermission(permissionKey);
      permissionSets.push(...mappedPermissions);
    });

    const hasPermission = this.userAuthService.hasPermission(permissionSets);
    if (hasPermission) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  private mapPermission(permissionKey: keyof Permission): UserPermission[] {
    const permissionMappings: Record<keyof Permission, UserPermission> = {
      practicePersonalInfoCreate: { moduleName: moduleName.practice, featureName: featureName.practicePersonalInfo, operationName: operationName.create },
      practicePersonalInfoEdit: { moduleName: moduleName.practice, featureName: featureName.practicePersonalInfo, operationName: operationName.write },
      practicePersonalInfoView: { moduleName: moduleName.practice, featureName: featureName.practicePersonalInfo, operationName: operationName.view },
      practicePersonalInfoDelete: { moduleName: moduleName.practice, featureName: featureName.practicePersonalInfo, operationName: operationName.delete },
      practicePersonalInfoAll: { moduleName: moduleName.practice, featureName: featureName.practicePersonalInfo, operationName: operationName.all },
    };

    const permission = permissionMappings[permissionKey];
    return permission ? [permission] : [];
  }
}
